import { useState, useRef, useEffect } from 'react';

/**
 * Hide-on-scroll-down / show-on-scroll-up para headers fixed/sticky.
 *
 * Oculta al bajar (a partir de `threshold` px) y reaparece al subir. Devuelve
 * un booleano `hidden` que la página usa para alternar una clase con
 * `transform: translateY(-100%)`.
 *
 * TOPBAR-UNIFY: extraído del listener inline de LandingPage para reutilizarlo
 * sin duplicar lógica (Home + SearchPage).
 *
 * @param {number} [threshold=80] scrollY mínimo antes de empezar a ocultar.
 * @returns {boolean} hidden
 */
export const useHideOnScroll = (threshold = 80) => {
  const [hidden, setHidden] = useState(false);
  const prevScrollY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const currentY = window.scrollY;
      // Hide on scroll down, show on scroll up
      if (currentY > prevScrollY.current && currentY > threshold) {
        setHidden(true);
      } else if (currentY < prevScrollY.current) {
        setHidden(false);
      }
      prevScrollY.current = currentY;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return hidden;
};

export default useHideOnScroll;
